import { defaultTheme } from './default.theme';
import { firstTheme } from './first.theme';
import type { PublicChatTheme } from './types';

export type { PublicChatTheme };

export const getTheme = (
  requestedTheme: string = import.meta.env['VITE_PUBLIC_CHAT_THEME'] || 'default'
): PublicChatTheme => {
  const themeName = requestedTheme.trim().toLowerCase();

  switch (themeName) {
    case 'first':
    case 'crimson':
      return firstTheme;
    case 'default':
    default:
      return defaultTheme;
  }
};
